<div class="conatiner-search">
    <ra-input
        [id]="'input-search-orders'"
        [placeholder]="'order.list.searchPlaceholder' | translate"
        [formControl]="searchControl"
        [showRequiredOrOptional]="false"
        [loading]="orderMainService.loading() && !!searchControl.value"
    />

    <ra-button
        [label]="'order.common.new' | translate"
        [type]="'primary'"
        [tooltip]="'order.list.addTooltip' | translate"
        (click)="isModalCreateOrderVisible.set(true)"
    />

    <ra-square-icon
        [id]="'square-icon-archived-orders'"
        [icon]="'archive'"
        [tooltip]="'order.list.archivedTooltip' | translate"
        [tooltipPosition]="'bottom'"
        (click)="isArchivedPanelVisible.set(true)"
    />
</div>

@if (isArchivedPanelVisible()) {
    <order-archived-panel (close)="isArchivedPanelVisible.set(false)" />
}

@if (orderMainService.loading() && !orderMainService.orders().length) {
    <div class="container-list-orders">
        @for (skeleton of skeletons; track $index) {
            <order-card-skeleton />
        }
    </div>
}
@else if (!orderMainService.orders().length) {
    <ra-empty
        animate.enter="empty-enter"
        [title]="'order.main.emptyTitle' | translate"
        [message]="'order.main.emptyMessage' | translate"
    />
}
@else {
    <div
        class="container-list-orders"
        (mouseenter)="isMouseInsideContainer.set(true)"
        (mouseleave)="isMouseInsideContainer.set(false)">
        @for (order of orderMainService.orders(); track order._id; let i = $index) {
            <order-card
                animate.enter="card-enter"
                animate.leave="card-leave"
                [style.--enter-delay]="(i % 10) * 40 + 'ms'"
                [order]="order"
                [active]="orderMainService.currentOrder()?._id === order._id"
                [isMouseInsideContainer]="isMouseInsideContainer()"
                (click)="orderMainService.setOrder(order)"
            />
        }
    </div>

    @if (orderMainService.loading()) {
        <div class="container-load-more">
            <ra-loading [size]="'small'" />
        </div>
    }
    @else if (orderMainService.paginate()?.page < orderMainService.paginate()?.totalPages) {
        <div class="container-load-more">
            <ra-button
                [label]="'order.common.loadMore' | translate"
                [type]="'primary'"
                (click)="getOrders(orderMainService.paginate()?.page + 1)" />
        </div>
    }
}

@if (isModalCreateOrderVisible()) {
    <order-create
        (close)="isModalCreateOrderVisible.set(false)"
        (created)="orderCreated($event)"
    />
}
